<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card-login card-white text-left">
          <template slot="header">
            <img src="@/assets/img/blip-logo.png" class="blip-logo" alt="" />
          </template>

          <div>
            <base-input v-validate="'required|min:3'" name="id" v-model="model.id" placeholder="ID" addon-left-icon="tim-icons icon-email-85"> </base-input>

            <base-input
              v-validate="'required|min:6'"
              name="password"
              v-model="model.password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <div slot="footer">
            <base-button native-type="submit" type="primary" class="mb-3" size="lg" block> 🕹 로그인 </base-button>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { Card, BaseInput } from "@/components/index";

export default {
  components: {
    Card,
    BaseInput,
  },
  data() {
    return {
      model: {
        id: null,
        password: null,
        subscribe: true,
      },
    };
  },
  methods: {
    async login() {
      const isFormValid = await this.$validator.validateAll();

      if (!isFormValid) {
        window.Toast.error("ID 와 패스워드를 올바로 입력해 주세요.");
        return;
      }

      try {
        const result = await this.$axios.post("/adminUsers/sessions", { username: this.model.id, password: this.model.password });
        this.$store.commit("setCurrentUser", result.data.data.adminUser);
        window.Toast.success("로그인에 성공하였습니다.");

        if (this.$route.query.redirect) {
          location.href = this.$route.query.redirect.replace(/\|/g, "&");
          // await this.$router.push(this.$route.query.redirect.replace(/\|/g, "&"));
        } else {
          location.href = "/";
          // await this.$router.push("/");
        }
      } catch (err) {
        const errorMsg = err.response.data.error.message;
        window.Toast.error(errorMsg);
      }
    },
  },
};
</script>
<style lang="scss">
.login-page {
  .content {
    padding-top: 40px;
    padding-bottom: 0;
  }

  .card-header {
    height: 180px;
  }

  .wrapper.wrapper-full-page {
    height: 100%;
  }

  .blip-logo {
    width: 100%;
  }

  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
}
</style>
